export class HeroPhoneInteractions {
  private sheet: HTMLElement | null = null;
  private toggle: HTMLButtonElement | null = null;
  private body: HTMLElement | null = null;
  private onClickBound: (() => void) | null = null;
  private onKeyDownBound: ((e: KeyboardEvent) => void) | null = null;

  constructor() {
    this.sheet = document.getElementById('hero-phone-sheet');
    this.toggle = document.getElementById('hero-phone-sheet-toggle') as HTMLButtonElement | null;
    this.body = document.getElementById('hero-phone-sheet-body');
    if (!this.sheet || !this.toggle || !this.body) return;

    this.onClickBound = () => this.toggleExpanded();
    this.onKeyDownBound = (e: KeyboardEvent) => {
      if (e.key === 'Escape') this.setExpanded(false);
    };

    this.toggle.addEventListener('click', this.onClickBound);
    document.addEventListener('keydown', this.onKeyDownBound);
  }

  private toggleExpanded(): void {
    if (!this.sheet || !this.toggle || !this.body) return;
    const isExpanded = this.sheet.classList.contains('is-expanded');
    this.setExpanded(!isExpanded);
  }

  private setExpanded(next: boolean): void {
    if (!this.sheet || !this.toggle || !this.body) return;
    this.sheet.classList.toggle('is-expanded', next);
    this.toggle.setAttribute('aria-expanded', String(next));
    this.body.setAttribute('aria-hidden', String(!next));
  }

  dispose(): void {
    if (this.toggle && this.onClickBound) {
      this.toggle.removeEventListener('click', this.onClickBound);
    }
    if (this.onKeyDownBound) {
      document.removeEventListener('keydown', this.onKeyDownBound);
    }
    this.sheet = null;
    this.toggle = null;
    this.body = null;
    this.onClickBound = null;
    this.onKeyDownBound = null;
  }
}

